export default __webpack_public_path__ + "static/media/likeAction.7c4ec781.svg";